import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Building2, CalendarDays, Home, Plus, Settings } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link, matchPath, useLocation } from "react-router";

export const MobileNavigation = () => {
  const location = useLocation();
  const translate = useTranslate();

  let currentPath: string | boolean = "/";
  if (matchPath("/", location.pathname)) {
    currentPath = "/";
  } else if (matchPath("/prospects/*", location.pathname)) {
    currentPath = "/prospects";
  } else if (matchPath("/activities/*", location.pathname)) {
    currentPath = "/activities";
  } else {
    currentPath = false;
  }

  // Check if the app is running as a PWA (standalone mode)
  const isPwa = window.matchMedia("(display-mode: standalone)").matches;
  // Check if it's iOS on the web
  const isWebiOS = /iPad|iPod|iPhone/.test(window.navigator.userAgent);

  return (
    <nav
      aria-label={translate("crm.navigation.label")}
      className="fixed bottom-0 left-0 right-0 z-50 bg-secondary h-14"
      style={{
        paddingBottom: isPwa && isWebiOS ? 15 : undefined,
        height:
          "calc(var(--spacing)) * 6" + (isPwa && isWebiOS ? " + 15px" : ""),
      }}
    >
      <div className="flex justify-center">
        <NavigationButton
          href="/"
          Icon={Home}
          label={translate("ra.page.dashboard")}
          isActive={currentPath === "/"}
        />
        <NavigationButton
          href="/prospects"
          Icon={Building2}
          label={translate("crm.navigation.prospects", { _: "List" })}
          isActive={currentPath === "/prospects"}
        />
        <NavigationButton
          href="/activities"
          Icon={CalendarDays}
          label={translate("crm.navigation.calendar", { _: "Calendar" })}
          isActive={currentPath === "/activities"}
        />
        <Button
          asChild
          variant="default"
          size="icon"
          className="h-16 w-16 rounded-full -mt-3"
          aria-label={translate("ra.action.create")}
        >
          <Link to="/prospects/create">
            <Plus className="size-10" />
          </Link>
        </Button>
        <NavigationButton
          href="/settings"
          Icon={Settings}
          label={translate("crm.settings.title")}
          isActive={!!matchPath("/settings", location.pathname)}
        />
      </div>
    </nav>
  );
};

const NavigationButton = ({
  href,
  Icon,
  label,
  isActive,
}: {
  href: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  isActive: boolean;
}) => (
  <Button
    asChild
    variant="ghost"
    className={cn(
      "flex-col gap-1 h-auto py-2 px-1 rounded-md w-16",
      isActive ? null : "text-muted-foreground",
    )}
  >
    <Link to={href}>
      <Icon className="size-6" />
      <span className="text-[0.6rem] font-medium">{label}</span>
    </Link>
  </Button>
);
